/**
 * Trigger GA4 event
 *
 * @param {object} data Event data
 * @param {string|null} resetKey Key to reset via sending an empty event before
 *   the requested one
 */
export const triggerEvent = (data, resetKey) => {
    window.dataLayer = window.dataLayer || [];
    if (resetKey) {
        window.dataLayer.push({[resetKey]: null});
    }
    dataLayer.push(data);
};